
import { phoneInputMask } from '../form/inputs'
import validateDefaults from '../validateDefaults'
import Modal from 'bootstrap/js/dist/modal'
const _token = $('meta[name="csrf-token"]').attr('content');

import AirDatepicker from 'air-datepicker';
// import 'air-datepicker/air-datepicker.css';

// import localeEn from 'air-datepicker/locale/en';
import localeRo from 'air-datepicker/locale/ro';
import localeRu from 'air-datepicker/locale/ru';


const returnForm = () => {

    const $formElm = $('#return__form');
    const $submitFormBtn = $('[data-submit-button-form]');
    const $form__col = $('.form__col');

    const successModal = new Modal('#successReturnModal');

    let formReturn;

    const appLocale = document.documentElement.lang;

    let currentLocale = localeRo;
    if(appLocale === 'ru') {
        currentLocale = localeRu;
    }

    new AirDatepicker('.form__input_date',{
        // isMobile: true,
        dateFormat: 'dd.MM.yyyy',
        maxDate: new Date(),
        toggleSelected: false,
        // inline: true,
        // isMobile: true,
        container: '.input_date_container',
        autoClose: true,
        locale: currentLocale,
        onSelect( {date, formattedDate, datepicker}) {
            const $input = $(datepicker.$el);
            const $inputContainer = $input.closest('.form__col');
            const $inputError = $inputContainer.find('.form__error');

            if (date) {
                $inputContainer.removeClass('has-error');
                $inputError.remove();
            }
        }
    })

    if ($('.phone__input_md').length) {
        formReturn = $formElm.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                email: {required: true, regexp: /(.+)@(.+)\.(.+)/i, maxlength: 255},
                phone: {required: true, regexp: /(?:(\+373))(?:\s*\d){8}$/},
                order_date: {required: true, minlength: 10, maxlength: 10},
                order_number: {required: true, maxlength: 255},
                account_iban: {required: true, maxlength: 34},
                account_holder: {required: true, maxlength: 255},
                reason: {required: true, maxlength: 2000},
                terms__rules_order: {custom_required: true},
            },
            ...validateDefaults
        });
    } else {
        formReturn = $formElm.validate({
            errorClass: "form__error",
            validClass: "has-value",
            errorElement: 'span',
            wrapper: false,
            onchange: false,
            rules: {
                name: {required: true, maxlength: 255},
                email: {required: true, regexp: /(.+)@(.+)\.(.+)/i, maxlength: 255},
                phone: {required: true, regexp: /(?:(\+40))(?:\s*\d){9}$/},
                order_date: {required: true, minlength: 10, maxlength: 10, regexp: /(\d{2})\.(\d{2})\.(\d{4})/},
                order_number: {required: true, maxlength: 255},
                account_iban: {required: true, maxlength: 34},
                account_holder: {required: true, maxlength: 255},
                reason: {required: true, maxlength: 2000},
                terms__rules_order: {custom_required: true},
            },
            ...validateDefaults
        });
    }

    $submitFormBtn.on('click', function () {
        $submitFormBtn.addClass('button__loading');

        const form = new FormData($formElm[0]);
        // const errorMessage = [];

        setTimeout(function () {
            $.ajax({
                url: '/retur',
                method: "POST",
                cache: false,
                data: form,
                processData: false,
                contentType: false,
                success: function (data) {
                    if (data.status === true) {
                        //success
                        $('.success-return-email').text(data.email);
                        $submitFormBtn.removeClass('button__loading');
                        successModal.show();
                        $formElm[0].reset();
                        $form__col.removeClass('has-value');
                    }
                },
                error: function (data) {
                    $formElm.find('.form__error').remove();
                    formReturn.form();


                    // if (data.responseJSON && data.responseJSON.status === false && data.responseJSON.details) {
                    //     $.each(data.responseJSON.details, function (fieldName, errorText) {
                    //        //тут ошибки
                    //         console.log(errorText)
                    //     });
                    // }

                    //error
                    $submitFormBtn.removeClass('button__loading');
                }
            });
        }, 350);
    });
};
jQuery(document).ready(function () {
    returnForm()
    phoneInputMask()
})
